import PropTypes from "prop-types";
import { CustomContainer, Form, Col } from "../../../DependencyHelper";
import formStyles from "../../NewLineForms.module.scss";
import DropDown from "../../dropDown/DropDown";

const PersonalDetailsForm = ({
  formName,
  fieldValues,
  fieldErrors,
  fieldErrorsMessage,
  onChangeHandler,
  titles,
  maritalStatusList,
  genders,
  onResetHandler,
  idType,
  onBlurHandler,
}) => {
  const handleChange = (event) => {
    onChangeHandler(event, null, formName);
  };
  const handleBlur = (event) => {
    onBlurHandler(event, null, formName);
  };

  return (
    <CustomContainer className={`${formStyles["main-container"]}`}>
      <Form.Row className={`${formStyles["main-row"]}`}>
        <Form.Row className={formStyles["form-row"]}>
          <Form.Group
            as={Col}
            xs="12"
            sm="6"
            md="6"
            className={`${formStyles["form-group"]}`}
            controlId={`validationFormpd101`}
          >
            <Form.Label
              className={formStyles["form-label"]}
              id={`validationFormpd101-label`}
            >
              Title
            </Form.Label>

            <DropDown
              formName={formName}
              name="title"
              label="Title"
              data={titles}
              required={true}
              handleSelect={onChangeHandler}
              handleReset={onResetHandler}
              handleBlur={handleBlur}
              resetRequired={true}
              selectedId={fieldValues["title"]}
              customId={`validationFormpd101`}
              fieldError={fieldErrors["title"]}
            />

            {fieldErrors["title"] && (
              <Form.Control.Feedback
                type="invalid"
                className={`${formStyles["invalid-feedback"]} ${formStyles["error"]}`}
              >
                {fieldErrorsMessage["title"]}
              </Form.Control.Feedback>
            )}
          </Form.Group>

          <Form.Group
            as={Col}
            xs="12"
            sm="6"
            md="6"
            className={formStyles["form-group"]}
            controlId={`validationFormpd102`}
          >
            <Form.Label
              className={formStyles["form-label"]}
              id={`validationFormpd102-label`}
            >
              Initials
            </Form.Label>
            <Form.Control
              type="text"
              name="initials"
              value={fieldValues["initials"]}
              placeholder="Add initials"
              required
              onBlur={handleBlur}
              onChange={handleChange}
              isInvalid={fieldErrors["initials"]}
              className={fieldErrors["initials"] ? formStyles["invalid"] : ""}
            />
            <Form.Control.Feedback
              type="invalid"
              className={formStyles["invalid-feedback"]}
            >
              {fieldErrorsMessage["initials"]}
            </Form.Control.Feedback>
          </Form.Group>
        </Form.Row>

        <Form.Group
          as={Col}
          sm="12"
          md="12"
          className={formStyles["form-group"]}
          controlId={`validationFormpd103`}
        >
          <Form.Label
            className={formStyles["form-label"]}
            id={`validationFormpd103-label`}
          >
            First name
          </Form.Label>
          <Form.Control
            type="text"
            name="firstName"
            value={fieldValues["firstName"]}
            placeholder="Add your first name"
            required
            onBlur={handleBlur}
            onChange={handleChange}
            isInvalid={fieldErrors["firstName"]}
            className={fieldErrors["firstName"] ? formStyles["invalid"] : ""}
          />
          <Form.Control.Feedback
            type="invalid"
            className={formStyles["invalid-feedback"]}
          >
            {fieldErrorsMessage["firstName"]}
          </Form.Control.Feedback>
          {!fieldErrors["firstName"] && (
            <div className={formStyles["hint-text"]}>
              {"As it appears on your ID / passport"}
            </div>
          )}
        </Form.Group>

        <Form.Group
          as={Col}
          sm="12"
          md="12"
          className={formStyles["form-group"]}
          controlId={`validationFormpd104`}
        >
          <Form.Label
            className={formStyles["form-label"]}
            id={`validationFormpd104-label`}
          >
            Surname
          </Form.Label>
          <Form.Control
            type="text"
            name="surName"
            value={fieldValues["surName"]}
            placeholder="Add your surname"
            required
            onBlur={handleBlur}
            onChange={handleChange}
            isInvalid={fieldErrors["surName"]}
            className={fieldErrors["surName"] ? formStyles["invalid"] : ""}
          />
          <Form.Control.Feedback
            type="invalid"
            className={formStyles["invalid-feedback"]}
          >
            {fieldErrorsMessage["surName"]}
          </Form.Control.Feedback>
          {!fieldErrors["surName"] && (
            <div className={formStyles["hint-text"]}>
              {"As it appears on your ID / passport"}
            </div>
          )}
        </Form.Group>
        {idType !== "SAID" && (
          <Form.Group
            as={Col}
            sm="12"
            md="12"
            className={formStyles["form-group"]}
            controlId={`validationFormpd105`}
          >
            <Form.Label
              className={formStyles["form-label"]}
              id={`validationFormpd105-label`}
            >
              Gender
            </Form.Label>
            <DropDown
              formName={formName}
              name="gender"
              label="Gender"
              data={genders}
              required={true}
              handleBlur={handleBlur}
              handleSelect={onChangeHandler}
              handleReset={onResetHandler}
              selectedId={fieldValues["gender"]}
              customId={`validationFormpd105`}
              resetRequired={true}
              fieldError={fieldErrors["gender"]}
            />

            {fieldErrors["gender"] && (
              <Form.Control.Feedback
                type="invalid"
                className={`${formStyles["invalid-feedback"]} ${formStyles["error"]}`}
              >
                {fieldErrorsMessage["gender"]}
              </Form.Control.Feedback>
            )}
          </Form.Group>
        )}
        {idType !== "SAID" && (
          <Form.Group
            as={Col}
            sm="12"
            md="12"
            className={formStyles["form-group"]}
            controlId={`validationFormpd106`}
          >
            <Form.Label
              className={formStyles["form-label"]}
              id={`validationFormpd106-label`}
            >
              Date of birth
            </Form.Label>
            <Form.Control
              type="text"
              name="dob"
              value={fieldValues["dob"]}
              placeholder="DD / MM / YYYY"
              required
              maxLength="14"
              onBlur={handleBlur}
              onChange={handleChange}
              isInvalid={fieldErrors["dob"]}
              className={fieldErrors["dob"] ? formStyles["invalid"] : ""}
            />
            <Form.Control.Feedback
              type="invalid"
              className={formStyles["invalid-feedback"]}
            >
              {fieldErrorsMessage["dob"]}
            </Form.Control.Feedback>
          </Form.Group>
        )}
        <Form.Group
          as={Col}
          sm="12"
          md="12"
          className={formStyles["form-group"]}
          controlId={`validationFormpd107`}
        >
          <Form.Label
            className={formStyles["form-label"]}
            id={`validationFormpd107-label`}
          >
            Marital status
          </Form.Label>
          <DropDown
            formName={formName}
            name="maritalStatus"
            label="Marital status"
            data={maritalStatusList}
            required={true}
            handleBlur={handleBlur}
            handleSelect={onChangeHandler}
            handleReset={onResetHandler}
            selectedId={fieldValues["maritalStatus"]}
            customId={`validationFormpd107`}
            resetRequired={true}
            fieldError={fieldErrors["maritalStatus"]}
          />
          {fieldErrors["maritalStatus"] && (
            <Form.Control.Feedback
              type="invalid"
              className={`${formStyles["invalid-feedback"]} ${formStyles["error"]}`}
            >
              {fieldErrorsMessage["maritalStatus"]}
            </Form.Control.Feedback>
          )}
        </Form.Group>
      </Form.Row>
    </CustomContainer>
  );
};

PersonalDetailsForm.propTypes = {
  formName: PropTypes.string,
  fieldValues: PropTypes.object,
  fieldErrors: PropTypes.object,
  fieldErrorsMessage: PropTypes.object,
  onChangeHandler: PropTypes.func,
  titles: PropTypes.array,
  maritalStatus: PropTypes.array,
  genders: PropTypes.array,
  onResetHandler: PropTypes.func,
  idType: PropTypes.string,
};

PersonalDetailsForm.defaultProps = {
  fieldValues: {},
  fieldErrors: {},
  fieldErrorsMessage: {},
  idType: "",
};

export default PersonalDetailsForm;
